import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCargaDatos } from '../Redux/V2/ContratoRedux';
//import { setCargaGeneral } from '../Redux/GeneralDuck';
import {
  Paper, Typography, Button, Grid, List, ListItem, Checkbox, ListItemText, CircularProgress, Box,
  Divider, Dialog, DialogTitle, DialogContent, TextField, Autocomplete, DialogActions
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Swal from 'sweetalert2';


const Causas = () => {
  const dispatch = useDispatch();

  const entrevista = useSelector((store) => store.contratoV2.Entrevista);
  const causasData = useSelector((store) => store.contratoV2.Causas || {});
  
  //const tribunales = useSelector((store) => store.general.tribunales || []);
  const tribunales = useSelector((store) => store.contratoV2.Tribunales || []);
  
  const acreedores = useSelector((store) => store.contratoV2.Acreedores || []);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion);
  const contrato = useSelector((store) => store.contratoV2.contrato);

  // ⬇️ nuevos selects para bloqueo por estado del contrato
  const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);

  const [isLoading, setIsLoading] = useState(true);
  const [disabledComponent, setDisabledComponent] = useState(false);
  const [causasDisponibles, setCausasDisponibles] = useState([]);
  const [causasSeleccionadas, setCausasSeleccionadas] = useState([]);
  const [checkedLeft, setCheckedLeft] = useState([]);
  const [checkedRight, setCheckedRight] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [newCausa, setNewCausa] = useState({ rut: '', rol: '', nombreCausa: '', tribunal: null, demandante: null });


  const [bloqueadoTotalmente, setBloqueadoTotalmente] = useState(!!contratoCancelado?.cancelado || !!contratoFiniquitado?.finiquitado || (contratoFirmado?.firmado && !disabledComponent))

  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) {
      if (actualizacion?.actualizacion?.type == 1) {
        setDisabledComponent(true)
        setBloqueadoTotalmente(true)
      } else {
        setDisabledComponent(false)
        setBloqueadoTotalmente(false)
      }

    } //Tipo=1 actualizacion normal - 2 cambio estratgia

  }, [actualizacion])

  useEffect(() => {
    setIsLoading(true);

    const promises = [
      dispatch(setCargaDatos("Acreedores", "get")),
      dispatch(setCargaDatos("Tribunales", "get"))
      //dispatch(setCargaGeneral("tribunales"))
    ];

    if (entrevista?.id) {
      promises.push(
        dispatch(setCargaDatos("Causas", "get", entrevista.id))
      );
    }

    Promise.all(promises)
      .catch(error => console.error("Error al cargar datos iniciales:", error))
      .finally(() => {
        setIsLoading(false);
      });

  }, [dispatch, entrevista?.id]);



  useEffect(() => {


    if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
      if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
        const _causasAct = actualizacion.actualizacionModelos.find(obj => obj.model == "causas");
        if (_causasAct != null) {

          const mapearCausaGcc = (c, i) => ({ ...c, uiId: `gcc-${c.id}-${i}`, name: c.nameCaratulado });
          const fromGcc = (JSON.parse(_causasAct.json)?.causasGcc || []).map(mapearCausaGcc)
          setCausasSeleccionadas((JSON.parse(_causasAct.json)?.causasGcc || []).map(mapearCausaGcc));

          if (causasData && (causasData.causasPjud || causasData.causasGcc)) {
            const mapearCausa = (c, i) => ({ ...c, uiId: `pjud-${c.id}-${i}`, name: c.nameCaratulado });
            const fromPJUD = (causasData.causasPjud || []).map(mapearCausa)
            const soloPjud = fromPJUD.filter(a =>
              !fromGcc.some(b => b.rol === a.rol && b.codTribunal === a.codTribunal)
            );
            setCausasDisponibles(soloPjud);
          }
          return
        }
      }
    }

    if (causasData && (causasData.causasPjud || causasData.causasGcc)) {
      const mapearCausa = (c, i) => ({ ...c, uiId: `pjud-${c.id}-${i}`, name: c.nameCaratulado });
      const mapearCausaGcc = (c, i) => ({ ...c, uiId: `gcc-${c.id}-${i}`, name: c.nameCaratulado });
      setCausasDisponibles((causasData.causasPjud || []).map(mapearCausa));
      setCausasSeleccionadas((causasData.causasGcc || []).map(mapearCausaGcc));
    }
  }, [causasData]);



  const handleToggle = (item, listSide) => {
    if (disabledComponent || bloqueadoTotalmente) return; // no permitir selección cuando está bloqueadoTotalmente
    const checked = listSide === 'left' ? checkedLeft : checkedRight;
    const setChecked = listSide === 'left' ? setCheckedLeft : setCheckedRight;
    const currentIndex = checked.findIndex(c => c.uiId === item.uiId);
    const newChecked = [...checked];
    if (currentIndex === -1) { newChecked.push(item); } else { newChecked.splice(currentIndex, 1); }
    setChecked(newChecked);
  };

  const handleMoveRight = () => {
    if (bloqueadoTotalmente) return;
    setCausasSeleccionadas(prev => prev.concat(checkedLeft));
    setCausasDisponibles(prev => prev.filter(item => !checkedLeft.some(c => c.uiId === item.uiId)));
    setCheckedLeft([]);
  };
  const handleMoveLeft = () => {
    if (bloqueadoTotalmente) return;
    setCausasDisponibles(prev => prev.concat(checkedRight));
    setCausasSeleccionadas(prev => prev.filter(item => !checkedRight.some(c => c.uiId === item.uiId)));
    setCheckedRight([]);
  };
  const handleMoveAllRight = () => {
    if (bloqueadoTotalmente) return;
    setCausasSeleccionadas(prev => prev.concat(causasDisponibles));
    setCausasDisponibles([]);
  };
  const handleMoveAllLeft = () => {
    if (bloqueadoTotalmente) return;
    setCausasDisponibles(prev => prev.concat(causasSeleccionadas));
    setCausasSeleccionadas([]);
  };

  const handleOpenDialog = () => {
    if (bloqueadoTotalmente) return; // no abrir diálogo si está bloqueadoTotalmente
    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setNewCausa({ rut: entrevista?.identifier || '', rol: '', nombreCausa: '', tribunal: null, demandante: null });
  };
  const handleInputChange = (e) => {
    if (bloqueadoTotalmente) return;
    const { name, value } = e.target;
    setNewCausa(prev => ({ ...prev, [name]: value }));
  };
  const handleAddCausaDesdeDialog = () => {
    if (bloqueadoTotalmente) return;
    if (!newCausa.rut || !newCausa.rol || !newCausa.nombreCausa || !newCausa.tribunal || !newCausa.demandante) {
      Swal.fire('Campos incompletos', 'Por favor, completa todos los campos requeridos.', 'warning');
      return;
    }
    console.log(newCausa)
    const causaParaAgregar = {
      rol: newCausa.rol,
      nameCaratulado: newCausa.nombreCausa,
      identifier: newCausa.rut,

      tribunal: newCausa.tribunal.label,
      codTribunal: newCausa.tribunal.id,
      demandante: newCausa.demandante.name,

      id: 0,
      proc: '',
      etapa: '',
      estadoProc: '',
      contractServiceId: 0,

      name: newCausa.nombreCausa,
      uiId: `manual-${Date.now()}`
    };
    setCausasSeleccionadas(prev => [...prev, causaParaAgregar]);
    Swal.fire('¡Agregada!', 'La nueva causa ha sido añadida a la lista.', 'success');
    handleCloseDialog();
  };

  const handleSubmit = async () => {
    if (bloqueadoTotalmente) {
      Swal.fire('Edición bloqueada', 'El contrato está cancelado, finiquitado o firmado. No es posible guardar cambios.', 'info');
      return;
    }
    var _causasSeleccionadas = causasSeleccionadas;
    const limpiarParaApi = (causa) => { const { uiId, name, ...resto } = causa; return resto; };

    if (causasSeleccionadas.some(x => x.serviceId == 0) && contrato != null && contrato.some(x => x.idService > 0)) {
      const idService = contrato.at(-1).idService;
      _causasSeleccionadas = causasSeleccionadas.map(c => c.serviceId === 0 ? { ...c, serviceId: idService } : c);
    }


    const payload = {
      interviewId: entrevista.id,
      causasPjud: causasDisponibles.map(limpiarParaApi),
      causasGcc: _causasSeleccionadas.map(limpiarParaApi),
    };

    try {

      if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
        var update = {
          json: JSON.stringify(payload),
          model: "causas",
          actualizacionId: actualizacion.actualizacion.id,
        }

        await dispatch(setCargaDatos("Actualizacion", "put", update));
        return;
      }



      const exito = await dispatch(setCargaDatos("Causas", "post", payload));
      if (exito) {
        Swal.fire({ icon: 'success', title: '¡Guardado!', text: 'La selección ha sido actualizada.', showConfirmButton: false, timer: 1500 });
        dispatch(setCargaDatos("Causas", "get", entrevista.id));
      } else {
        Swal.fire({ icon: 'error', title: 'Error al guardar', text: 'El servidor no pudo procesar la solicitud.' });
      }


    } catch (error) {
      console.error("Error en handleSubmit:", error);
      Swal.fire({ icon: 'error', title: 'Error de Conexión', text: 'No se pudo comunicar con el servidor.' });
    }
  };

  const customList = (title, items, listSide) => (
    <Paper sx={{ width: 500, height: 300, overflow: 'auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" component="div">{title}</Typography>
        {listSide === 'right' && (
          <Button
            color="primary"
            aria-label="agregar causa manual"
            onClick={handleOpenDialog}
            disabled={disabledComponent || bloqueadoTotalmente}
            startIcon={<AddIcon />}
          >
            Agregar Causa Manual
          </Button>
        )}
      </Box>
      <Divider />
      <List dense>
        {items.map(item => (
          <ListItem
            key={item.uiId}
            role="listitem"
            button
            onClick={() => handleToggle(item, listSide)}
            disabled={bloqueadoTotalmente}
          >
            <Checkbox
              disabled={bloqueadoTotalmente}
              checked={(listSide === 'left' ? checkedLeft : checkedRight)
                .findIndex(c => c.uiId === item.uiId) !== -1}
            />
            <ListItemText primary={item.name} secondary={`${item.rol} - ${item.tribunal}`} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );


  const acreedoresUniq = useMemo(() => {
    const seen = new Set();
    if (!Array.isArray(acreedores)) return []
    return acreedores.filter(a => {
      const k = (a.id ?? a.name?.toLowerCase().trim());
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }, [acreedores]);

  return (
    <>
      <Typography variant="h5" sx={{ mb: 2 }}> Asignación de Causas a Tramitar</Typography>
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid size={5}>{customList('Causas PJUD', causasDisponibles, 'left')} </Grid>
          <Grid size={1}>
            <Grid container direction="column" alignItems="center">
              <Button onClick={handleMoveAllRight} disabled={disabledComponent || bloqueadoTotalmente || causasDisponibles.length === 0} variant='outlined' sx={{ my: 0.8 }}>&gt;&gt;</Button>
              <Button onClick={handleMoveRight} disabled={disabledComponent || bloqueadoTotalmente || checkedLeft.length === 0} variant='outlined' sx={{ my: 0.8 }}>&gt;</Button>
              <Button onClick={handleMoveLeft} disabled={disabledComponent || bloqueadoTotalmente || checkedRight.length === 0} variant='outlined' sx={{ my: 0.8 }}>&lt;</Button>
              <Button onClick={handleMoveAllLeft} disabled={disabledComponent || bloqueadoTotalmente || causasSeleccionadas.length === 0} variant='outlined' sx={{ my: 0.8 }}>&lt;&lt;</Button>
            </Grid>
          </Grid>
          <Grid size={5}>{customList('Causas GCC', causasSeleccionadas, 'right')}</Grid>
        </Grid>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5, mb: 2 }}>
        <Button
          type="submit"
          variant="contained"
          disabled={isLoading || disabledComponent || bloqueadoTotalmente}
          onClick={handleSubmit}
        >
          Guardar Selección
        </Button>
      </Box>

      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md">
        <DialogTitle>Agregar Nueva Causa Manual</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField required fullWidth name="rut" label="Rut" value={newCausa.rut} onChange={handleInputChange} disabled={bloqueadoTotalmente} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField required fullWidth name="rol" label="Rol" value={newCausa.rol} onChange={handleInputChange} autoFocus disabled={bloqueadoTotalmente} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                fullWidth
                options={tribunales}
                getOptionLabel={(option) => option.label || ''}
                value={newCausa.tribunal}
                onChange={(e, val) => !bloqueadoTotalmente && setNewCausa(p => ({ ...p, tribunal: val }))}
                renderInput={(params) => <TextField {...params} label="Seleccione Tribunal" required disabled={bloqueadoTotalmente} />}
                disabled={bloqueadoTotalmente}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField required fullWidth name="nombreCausa" label="Nombre Causa - Caratula" value={newCausa.nombreCausa} onChange={handleInputChange} disabled={bloqueadoTotalmente} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                fullWidth
                options={acreedoresUniq}
                getOptionLabel={(option) => option?.name ?? ""}
                // Muy importante para que no “re-renderice” comparando por referencia:
                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                value={newCausa.demandante ?? null} // debe ser un objeto de options o null
                onChange={(e, val) => !bloqueadoTotalmente && setNewCausa(p => ({ ...p, demandante: val }))}
                // Asegura key única en cada <li>:
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>{option.name}</li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione un demandante" required disabled={bloqueadoTotalmente} />
                )}
                disabled={bloqueadoTotalmente}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: '16px 24px' }}>
          <Button onClick={handleCloseDialog} variant="outlined" color="secondary">Cerrar</Button>
          <Button onClick={handleAddCausaDesdeDialog} variant="contained" color="primary" disabled={bloqueadoTotalmente}>Crear</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Causas;
